module.exports = __webpack_public_path__ + "img/wxminigame.6fe56814.png";